"use strict";
var zip_1 = require('../operators/zip');
exports.zip = zip_1.zipStatic;
